import {
  getPetitionDetail,
  getPetitionStatusPdf,
} from '../../../api/petitionsHistoryRequests';

export async function fetchPetitionDetaiAndFiles(petitionId: number) {
  const petition = await getPetitionDetail(petitionId);

  if (petition.error || !petition.data) {
    return petition;
  }

  if (petition.data?.linkedFiles && petition.data.linkedFiles.length > 0) {
    const pdfFiles = await Promise.all(
      petition.data.linkedFiles.map(async (file: any) => {
        const responseFile = await getPetitionStatusPdf(file.id);
        return responseFile.data;
      }),
    );
    petition.data.pdfFiles = pdfFiles;
  }

  if (petition.data.linkedFileResponse) {
    const responseFile = await getPetitionStatusPdf(
      petition.data.linkedFileResponse.id,
    );
    petition.data.fileResponse = responseFile.data;
  }
  return petition;
}
